import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgbTabsetModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {DocumentsPageComponent} from './documents-page.component';
import {DocumentsService} from './model/documents-service';

/**
 * Created by Arturo Campos on 20/09/18.
 */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgbTabsetModule,
        NgbTooltipModule,
    ],
    declarations: [DocumentsPageComponent],
    providers: [DocumentsService],
})
export class DocumentsPagesModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/documents/documents-pages.module.ts